import pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
import { logoPecsmart } from '../base64/logoPecsmart';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

pdfMake.vfs = pdfFonts?.pdfMake?.vfs;

/**
 * Generate PDF for consolidated 8h interval (entradas/saídas per silo).
 * @param {Object} singleInterval - { silos: { [siloId]: { siloName, subida, descida } }, siloOrder: Array<{ id, name }>, endDate }
 * @param {Object} locationInfo - { farmName, barnName }
 * @param {string} startDate
 * @param {string} effectiveEnd
 */
export const generateConsolidated8hPDF = (singleInterval, locationInfo, startDate, effectiveEnd) => {
  if (!singleInterval || !singleInterval.silos || !singleInterval.siloOrder) {
    console.error('No hay datos para exportar');
    return;
  }

  const startStr = startDate ? format(new Date(startDate), 'dd/MM/yyyy HH:mm', { locale: ptBR }) : 'N/A';
  const endStr = effectiveEnd ? format(new Date(effectiveEnd), 'dd/MM/yyyy HH:mm', { locale: ptBR }) : 'N/A';
  const fileName = `Consolidado 8h - ${locationInfo.farmName} - ${locationInfo.barnName} - ${startStr} - ${endStr}.pdf`;

  const tableBody = [
    [
      { text: 'Silo', style: 'tableHeader', alignment: 'center' },
      { text: 'Entradas (kg)', style: 'tableHeader', alignment: 'center' },
      { text: 'Saídas (kg)', style: 'tableHeader', alignment: 'center' }
    ]
  ];

  singleInterval.siloOrder.forEach(({ id, name }) => {
    const silo = singleInterval.silos[id] || {};
    tableBody.push([
      { text: silo.siloName || name || `Silo ${id}`, alignment: 'center' },
      { text: Number(silo.subida || 0).toFixed(2), alignment: 'center' },
      { text: Number(silo.descida || 0).toFixed(2), alignment: 'center' }
    ]);
  });

  const content = [
    {
      columns: [{ image: logoPecsmart, width: 120, margin: [0, 0, 0, 20], alignment: 'center' }],
      alignment: 'center'
    },
    { text: 'Consolidado 8h - Entradas / Saídas', style: 'mainHeader', alignment: 'center', margin: [0, 0, 0, 5] },
    { text: `${locationInfo.farmName} - ${locationInfo.barnName}`, style: 'locationInfo', alignment: 'center', margin: [0, 0, 0, 5] },
    { text: `${startStr} - ${endStr}`, style: 'subHeader', alignment: 'center', margin: [0, 0, 0, 30] },
    {
      table: { headerRows: 1, widths: ['*', 'auto', 'auto'], body: tableBody },
      layout: { fillColor: (rowIndex) => (rowIndex % 2 === 0 ? '#FFFFFF' : '#F8F9FA') },
      margin: [0, 0, 0, 20]
    }
  ];

  const documentDefinition = {
    pageSize: 'A4',
    pageMargins: [40, 60, 40, 20],
    content,
    styles: {
      mainHeader: { fontSize: 16, bold: true, margin: [0, 10, 0, 0] },
      locationInfo: { fontSize: 12, bold: true, margin: [0, 5, 0, 0] },
      subHeader: { fontSize: 12, italic: true, color: '#666666', margin: [0, 5, 0, 0] },
      tableHeader: { bold: true, fontSize: 9, color: 'black', fillColor: '#eeeeee' }
    },
    defaultStyle: { fontSize: 9 }
  };

  pdfMake.createPdf(documentDefinition).download(fileName);
};
